var activePointer = function activePointer(pointers, id) {
  pointers.forEach(function (pointer) {
    if (pointer.dataset.id === id) {
      pointer.classList.add('active');
    } else {
      pointer.classList.remove('active');
    }
  });
};
var scrollingToPoint = function scrollingToPoint(id) {
  var point = document.querySelector("#".concat(id));
  var y = point.getBoundingClientRect().top + window.scrollY - 96;
  window.scroll({
    top: y,
    behavior: 'smooth'
  });
};
var initPointers = function initPointers() {
  var pointers = document.querySelectorAll('.pointer-js');
  if (!pointers) {
    return;
  }
  pointers.forEach(function (pointer) {
    pointer.addEventListener('click', function () {
      var id = pointer.dataset.id;
      activePointer(pointers, id);
      scrollingToPoint(id);
    });
  });
};
export { initPointers };